import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { AXIOS_INSTANCE, type ErrorType } from '@/api/httpClient';

// API 응답 타입
interface SubjectItem {
  categoryTreeId: string;
  categoryGroupId: string;
  type: string;
  name: string;
  order: number;
  parentId: string;
  ancestors: string[];
  children: unknown[];
  localizeNames: Record<string, string>;
}

interface GetSubjectsResponse {
  status: string;
  message: string | null;
  data: SubjectItem[];
}

// 반환 타입
export interface SubjectOption {
  name: string;
  categoryTreeId: string;
}

// API 파라미터 타입
interface GetSubjectsParams {
  countryCode: string;
  schoolType: string;
  grade: number;
}

const getSubjectsByCountry = async (
  params: GetSubjectsParams,
): Promise<GetSubjectsResponse> => {
  const { data } = await AXIOS_INSTANCE.get<GetSubjectsResponse>(
    '/category-trees/subjects',
    {
      params: {
        countryCode: params.countryCode,
        schoolType: params.schoolType,
        grade: params.grade,
      },
    },
  );
  return data;
};

export const useGetSubjectsByCountry = (
  params: GetSubjectsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<GetSubjectsResponse, ErrorType<unknown>, SubjectOption[]>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  return useQuery<GetSubjectsResponse, ErrorType<unknown>, SubjectOption[]>({
    queryKey: ['sign-up-subjects', params],
    queryFn: () => getSubjectsByCountry(params),
    enabled: !!params.countryCode && !!params.schoolType && params.grade >= 0,
    select: data =>
      data.data.map(item => ({
        name: item.name,
        categoryTreeId: item.categoryTreeId,
      })),
    ...queryOptions,
  });
};
